







import { Component, Vue } from 'vue-property-decorator'
@Component({
  name: 'inDevelopment'
})
export default class InDevelopment extends Vue {
  initCharts () {
    // const ROOT_PATH = 'https://cdn.jsdelivr.net/gh/apache/echarts-website@asf-site/examples'
    var myChart = (this as any).$echarts.init(document.getElementById('echartsContainer'))
    window.onresize = function () {
      myChart.resize()
    }
    let option = {
      backgroundColor: '#000',
      globe: {
        baseTexture: require('../../assets/images/charts/world.jpg'),
        heightTexture: require('../../assets/images/charts/world.jpg'),
        displacementScale: 0.04,
        shading: 'realistic',
        environment: require('../../assets/images/charts/starfield.jpg'),
        realisticMaterial: {
          roughness: 0.9
        },
        postEffect: {
          enable: true
        },
        light: {
          main: {
            intensity: 5,
            shadow: true
          }
          // ambientCubemap: {
          //   texture: ROOT_PATH + '/data-gl/asset/pisa.hdr',
          //   diffuseIntensity: 0.2
          // }
        },
        viewControl: {
          // autoRotateDirection: 'ccw', // 反转
          // autoRotate: true，
          // rotateSensitivity: 0,
          // projection: 'orthographic',
          // orthographicSize: 110, // 控制地图大小
          // maxOrthographicSize: 110,
          // minOrthographicSize: 110,
          // autoRotate: false,
          // animation: true,
          // alpha: 60,
          // beta: 10,
          // animationDurationUpdate: 1000
          // autoRotateSpeed:5
        }
      }
    }
    myChart.setOption(option)
  }

  mounted () {
    this.initCharts()
  }

  // mounted () {
  //   // 演示关系线：
  //   var myChart = (this as any).$echarts.init(document.getElementById('main'))
  //   let option = {
  //     title: {
  //       text: '关系图'
  //     },
  //     tooltip: {},
  //     series: [
  //       {
  //         // name: '知识图谱',
  //         type: 'graph',
  //         hoverAnimation: true,
  //         layout: 'force',
  //         force: {
  //           repulsion: 300,
  //           edgeLength: 100
  //         },
  //         edgeSymbol: ['circle', 'arrow'],
  //         edgeSymbolSize: [0, 0],
  //         label: {
  //           show: true,
  //           position: 'right',
  //           color: 'red',
  //           distance: 5,
  //           fontSize: 10
  //         },
  //         data: [
  //           {
  //             symbolSize: 100,
  //             name: '食堂管理',
  //             id: '-1'
  //           },
  //           {
  //             symbolSize: 80,
  //             name: '首页',
  //             id: '0',
  //             lineStyle: { color: 'purple' },
  //             itemStyle: {
  //               // color: {
  //               //     type: 'radial',
  //               //     x: 0.5,
  //               //     y: 0.5,
  //               //     r: 0.5,
  //               //     colorStops: [
  //               //         {
  //               //             offset: 0,
  //               //             color: "#00DEDE" // 0% 处的颜色
  //               //         },
  //               //         {
  //               //             offset: 0.8,
  //               //             color: "#00DEDE" // 80% 处的颜色
  //               //         },
  //               //         {
  //               //             offset: 1,
  //               //             color: "#00DEDE" // 100% 处的颜色
  //               //         }
  //               //     ],
  //               //     global: false
  //               // },
  //               // normal: {
  //               color: 'red',
  //               // },
  //               shadowColor: '#00DEDE',
  //               shadowBlur: 15
  //             },
  //             label: {
  //               show: true,
  //               position: 'right',
  //               rotate: 0,
  //               textStyle: {
  //                 fontSize: 22,
  //                 color: '#CACACA'
  //               }
  //             }
  //           }
  //         ],
  //         links: [
  //           {
  //             source: '-1',
  //             target: '0',
  //             lineStyle: {
  //               color: '#23DFDF',
  //               width: 2,
  //               type: 'dashed',
  //               cap: 'butt'
  //             }
  //           }
  //         ],
  //         lineStyle: {
  //           color: 'red'
  //         }
  //       }
  //     ]
  //   }
  //   myChart.setOption(option)
  // }
}
